/*====================================
=            ON DOM READY            =
====================================*/
$(function() {
  $('.js-toggle-newsletter').click(function() {
    // Calling a function in case we want to expand upon this.
    toggleNewsletter();
  });

});

/*========================================
=            CUSTOM FUNCTIONS            =
========================================*/
function toggleNewsletter() {
  var $items =  $('.newsletter-banner, .newsletter');
  $('.newsletter-banner').addClass('has-clicked');
  $items.toggleClass('is-open');
}